import {Component, Input, OnInit} from '@angular/core';
import {AttendanceListProvider, OrderTissEditProvider, OrderTissListProvider, PageOptions} from 'cw-backend';
import {FormBuilder, FormControl, FormGroup, Validators} from "@angular/forms";
import {OrderTissDeclaration} from "../../../../../../../shared/cw-backend/models/attendance/order-tiss-declaration";
import {
    OrderTissDeclarationEditProvider
} from "../../../../../../../shared/cw-backend/providers/attendance/order-tiss-declaration/order-tiss-declaration-edit-provider.service";
import {
    OrderTissDeclarationListProvider
} from "../../../../../../../shared/cw-backend/providers/attendance/order-tiss-declaration/order-tiss-declaration-list-provider.service";
import {debounceTime, distinctUntilChanged, takeUntil} from 'rxjs/operators';
import {Subject} from 'rxjs';
import {SnackBarService} from 'cw-utils';
import {MatDialog} from '@angular/material/dialog';
import {FuseConfirmDialogComponent} from '../../../../../../@fuse/components/confirm-dialog/confirm-dialog.component';

@Component({
    selector: 'cw-order-tiss-declaration',
    templateUrl: './order-tiss-declaration.component.html',
    styleUrls: ['./order-tiss-declaration.component.scss']
})
export class OrderTissDeclarationComponent implements OnInit {

    @Input() orderTissId: number;

    orderTissDeclarationForm: FormGroup;
    orderTissDeclarationList: OrderTissDeclaration;
    cidList = new Array<any>();
    cidPageOptions = new PageOptions();

    displayedColumns: string[] = ['birthDeclaration', 'cid', 'deathDeclaration', 'dornIndicator', 'action'];

    private _unsubscribeAll: Subject<any> = new Subject<any>();

    modeEdit = false;
    loading = false;

    constructor(
        private orderTissDeclarationEditProvider: OrderTissDeclarationEditProvider
        ,private orderTissDeclarationListProvider: OrderTissDeclarationListProvider
        ,private _formBuilder: FormBuilder
        ,private attendanceListProvider: AttendanceListProvider
        ,private snackBar: SnackBarService
        ,private _matDialog: MatDialog
    ) { }

    ngOnInit(): void {
        this.getTissDeclaration();
        this.getCids();
        this.orderTissDeclarationForm = this.createOrderTissDeclarationForm();
        this.filterCid();
    }

    getTissDeclaration(){
        this.orderTissDeclarationListProvider
            .getById(this.orderTissId)
            .then(res=>{
                this.orderTissDeclarationList = res.body
            })
    }

    createOrderTissDeclarationForm() {
        return this._formBuilder.group({
            id: [null],
            orderTiss: [{id:this.orderTissId}],
            cid: [null],
            birthDeclaration: [null],
            deathDeclaration: [null],
            dornIndicator: [null]
        });
    }

    insert(){
        this.loading = true;
        let data = this.orderTissDeclarationForm.getRawValue();
        if (data.cid == null &&
            data.birthDeclaration == null  &&
            data.deathDeclaration == null &&
            data.dornIndicator == null){
            this.snackBar.warnMessage("Para salvar, ao menos um dos campos deve estar preenchido.")
            this.loading = false;
            return;
        }
        this.orderTissDeclarationEditProvider
            .insert(data)
            .then(res =>{
                this.snackBar.successMessage(res.body.message);
                this.getTissDeclaration();
                this.resetForm();
                this.loading = false;
            }).catch(err =>{this.loading = false;})
    }

    edit(data){
        this.modeEdit = true;
        this.orderTissDeclarationForm.
        setValue({
            id: data.id,
            orderTiss: {id:this.orderTissId},
            cid: data.cid,
            birthDeclaration: data.birthDeclaration,
            deathDeclaration: data.deathDeclaration,
            dornIndicator: data.dornIndicator,
        });
    }

    confirDelete(data){
        let dialog = this._matDialog.open(FuseConfirmDialogComponent, {
            disableClose: true,
        });
        dialog.componentInstance.action = "confirm";
        dialog.afterClosed()
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe({
                next: (result) => {
                    if (result) {
                        this.delete(data.id);
                    }
                }
            });
    }


    delete(id){
        this.orderTissDeclarationEditProvider
            .delete(id)
            .then(res =>{this.snackBar.successMessage(res.body.message);})
            .catch(err =>{this.snackBar.errorMessage(err.message)})
            .finally(() => {this.resetForm(); this.getTissDeclaration();});
    }

    cancel(){
        this.modeEdit = false;
        this.resetForm();
    }

    resetForm(){
        this.modeEdit = false;
        this.orderTissDeclarationForm.
        setValue({
            id: null,
            orderTiss: {id:this.orderTissId},
            cid: null,
            birthDeclaration: null,
            deathDeclaration: null,
            dornIndicator: null
        });
    }

    checkDornIndicator(data){
        let result = '';
        switch(data.dornIndicator){
            case 'S':
                result = 'Sim';
                break;
            case 'N':
                result = 'Não';
                break;
        }
        return result;
    }

    getCids() {
        this.attendanceListProvider.getCids(this.cidPageOptions).then((res) => {
            this.cidList = res.body.content;
        });
    }

    filterCid() {
        this.orderTissDeclarationForm.controls['cid'].valueChanges
            .pipe(
                takeUntil(this._unsubscribeAll),
                debounceTime(500),
                distinctUntilChanged()
            )
            .subscribe((res) => {
                if (res && res.id) {
                    this.cidPageOptions.argument = res.name;
                } else if (res && typeof res === "string") {
                    this.cidPageOptions.argument = res;
                } else {
                    this.cidPageOptions.argument = "";
                }

                this.getCids();
            });
    }

    displayCIDFn(cid?: any): string | undefined {
        if (!cid) {
            return "";
        }
        return `${cid.name} - ${cid.code}`;
    }

    compareEnum(o1: any, o2: any): boolean {
        if (o1 == null || o2 == null) {
            return null;
        }
        return o1 === o2;
    }

}
